import * as React from 'react';
import { Heading, Text } from '@grandvisionhq/elements';
import { Alert } from '@grandvisionhq/iris-ui';

const MultibancoSummary = ({ labels , paymentExternalId , paymentExternalReference  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "multibanco-payment-info"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "multibanco-payment-info--row"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "multibanco-payment-info__label"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "multibanco-payment-info__heading",
        variant: "subheading2"
    }, labels.multibancoEntity)), /*#__PURE__*/ React.createElement("div", {
        className: "multibanco-payment__value"
    }, /*#__PURE__*/ React.createElement(Text, {
        component: "span"
    }, paymentExternalId))), /*#__PURE__*/ React.createElement("div", {
        className: "multibanco-payment-info--row"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "multibanco-payment-info__label"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "multibanco-summary-info__heading",
        variant: "subheading2"
    }, labels.multibancoReference)), /*#__PURE__*/ React.createElement("div", {
        className: "multibanco-payment-info__value"
    }, /*#__PURE__*/ React.createElement(Text, {
        component: "span"
    }, paymentExternalReference))), /*#__PURE__*/ React.createElement("div", {
        className: "multibanco-payment-info--row"
    }, /*#__PURE__*/ React.createElement(Alert, {
        className: "alert-m-default multibanco-payment-info__alert",
        title: labels.multibancoTitle
    }, labels.multibancoMessage))))
;

export { MultibancoSummary };
//# sourceMappingURL=MultibancoSummary.js.map
